module.exports = __webpack_public_path__ + "assets/badge-module-2.ef4ffd62d18323e4e890296d939ca743.svg";